import React from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';

import { Dialog, DialogContent } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

import ModalHeader from './ModalHeader';

import ModalStore from '../../stores/ModalStore';

const scheduleModalStyles = makeStyles({
  root: {
    '& .MuiPaper-root': {
      borderRadius: '6px',
    },
  },
});

function ScheduleModal(props) {
  const {
    children,
    title,
    maxWidth,
    modalStore: { show },
  } = props;
  const classes = scheduleModalStyles();

  return (
    <Dialog open={show} maxWidth={maxWidth} className={classes.root}>
      <ModalHeader>{title}</ModalHeader>
      <DialogContent dividers>{children}</DialogContent>
    </Dialog>
  );
}

ScheduleModal.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  maxWidth: PropTypes.string,
  modalStore: PropTypes.instanceOf(ModalStore).isRequired,
};

ScheduleModal.defaultProps = {
  maxWidth: 'xs',
};

export default inject('modalStore')(observer(ScheduleModal));
